export enum HeaderLanguageEnum {
  ITA = 'it-IT',
}

export const Patterns = Object.freeze({
  EMAIL: /^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
  FIRST_NAME: /^[a-zA-ZäöüÄÖÜß](?:[a-zA-ZäöüÄÖÜß\- ]{0,38}[a-zA-ZäöüÄÖÜß])?$/,
  LAST_NAME: /^[a-zA-ZäöüÄÖÜß](?:[a-zA-ZäöüÄÖÜß\- ]{0,38}[a-zA-ZäöüÄÖÜß])?$/,
  COMPANY_NAME: /^[a-zA-ZäöüÄÖÜß\- +&.]{2,40}$/,
  STREET: /^[[A-Za-zÄÖÜäöüß0-9 .-]+$/,
  HOUSE_NUMBER: /^[A-Za-zÄÖÜäöüß0-9 .]+$/,
  CITY: /^[a-zA-ZäöüßÄÖÜ \\-]+$/,
  PLATEVEHICLE: /^([a-zA-z]{2})(\d{3})(\d{2})?(\d{3})?([a-zA-z]{2})?$/,
  FISCALCODE:
    /\b^[a-zA-Z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[a-zA-Z][0-9lmnpqrstuvLMNPQRSTUV]{2}[a-zA-Z][0-9lmnpqrstuvLMNPQRSTUV]{3}[a-zA-Z]$\b/,
  COMPANYFISCALCODE: /\b\d{11}\b/,
  ZIPCODE: /\b\d{5}\b/,
  ABI_CAB: /\b\d{4,5}\b|(^$)/,
  PARTNERSHIPNUMBER: /[a-zA-Z0-9]{1,13}/,
  PARTNERSHIPNUMBERCUSTOM: /[a-zA-Z0-9]{1,8}/,
  VERTI_POLICY_NUMBER: /^(AID|MTR|LFW|TCR)[0-9].{0,8}$/,
  OTHER_INSURER_POLICY_NUMBER: /^[A-Za-z0-9][A-Za-z0-9_\-\.\/: ]{3,19}$/,
  HSN: /^\d{4}$/,
  TSN: /^[a-zA-Z0-9]{3}$/,
  GERMAN_IBAN: /^(DE)([0-9]{2} )(?:[0-9]{4} ){4}([0-9]{2})$/,
  INTERNATIONAL_IBAN: /^(?!DE)[A-Z]{2}[0-9 ]{4,40}$/,
  GENERIC_IBAN: /^(?:AD|AT|BE|BG|CH|CY|CZ|DE|DK|EE|ES|FI|FR|GB|GI|GR|HR|HU|IE|IS|IT|LI|LT|LU|LV|MC|MT|NL|NO|PL|PT|RO|SE|SI|SK|SM|VA)\d{2}(?:\s?[A-Z0-9]{4}){2,7}(?:\s?[A-Z0-9]{1,4})?$/,
  IBAN: /^(?:DE[0-9]{2} (?:[0-9]{4} ){4}[0-9]{2}|(?!DE)[A-Z]{2}[0-9 ]{4,40})$/,
  DATE_SLASH_YYYYMMDD: 'YYYY/MM/DD',
  DATE_SLASH_DDMMYYYY: 'DD/MM/YYYY',
  DATE_DASH_YYYYMMDD: 'YYYY-MM-DD',
  DATE_DOT_DDMMYYYY: 'DD.MM.YYYY',
  DATE_WITHOUT_SEPARATION_YYYYMMDD: 'YYYYMMDD',
  DATE_WITHOUT_SEPARATION_DDMMYYYY: 'DDMMYYYY',
  DATE_WITH_TIME: 'YYYYMMDD_hhmmss',
  DATE_DOT: /^([1-9]|0[1-9]|[12][0-9]|3[01])\.([1-9]|0[1-9]|1[012])\.(19|20)\d\d$/,
  REFERRAL_CODE: /^(VERTI)(A|[0-9]|X)(?:[A-Za-z0-9]{6})$/,
  PHONE_AREA: /^0\d{2,5}$/,
  PHONE: /^[0-9]\d{3,11}$/,
  ANNUAL_KILOMETERS: /^([1-9]|[1-9][0-9])$/,
  IDENTIFICATION_NUMBER: /^[a-zA-Z0-9]{7,25}$/,

  PASSWORD:
    /^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!-/:-@[-`{-}])|(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])|(?=.*[A-Z])(?=.*[a-z])(?=.*[!-/:-@[-`{-}])|(?=.*[A-Z])(?=.*[0-9])(?=.*[!-/:-@[-`{-}])|(?=.*[a-z])(?=.*[0-9])(?=.*[!-/:-@[-`{-}]))(?!.*\s).{8,}$/,
  PROMOCODE: /^[0-9A-Z]+$/,

  YEAR_AUTO: /^(1949|19[5-9]\d|20\d\d)$/,
  YEAR_MOTO: /^(1950|19[5-9]\d|20\d\d)$/,
  YEAR_VAN: /^(1981|198[2-9]|19[9][0-9]|20\d\d)$/,

  LIMIT_POSTCODE: '5',
  LIMIT_HSN: '4',
  LIMIT_TSN: '3',
  LIMIT_STREET: '10',
  LIMIT_HOUSE_NUMBER: '5',
  LIMIT_CITY: '40',
  LIMIT_LICENSE_PLATE_PREFIX: '3',
  LIMIT_LICENSE_PLATE_SUFFIX1: '2',
  LIMIT_LICENSE_PLATE_SUFFIX2: '4',
  LIMIT_IBAN: '42',
});

export const Masks = Object.freeze({
  PHONE: '(+39) 000 000 0000',
  PHONE_MASK_REPLACER: { 0: '[0-9]' },
  DATE: '99/99/9999',
  DATE_DOT: '99.99.9999',
  ZIPCODE: '99999',
  AMOUNT: 'NNNNNN',
  AMOUNT_MASK_REPLACER: { N: '[0-9]' },
  HSN: '9999',
  TSN: 'DDD',
  TSN_REPLACER: { D: '[a-zA-Z0-9]' },
  PROMO_CODE: /^\d{0,20}$/,
  PROMO_CODE_REPLACER: { D: '[a-zA-Z0-9]' },
  LICENSE_PLATE_SUFFIX_1: 'xx',
  LICENSE_PLATE_SUFFIX_2: '9999',
  MILEAGE: '999999',
});

export enum LinkOpenEnum {
  NEW_TAB = '_blank',
  SAME_TAB = '_self',
}

export enum QuestionEnum {
  YES = 'Ja',
  NO = 'Nein',
}

export enum LiabilityClaimsNumberEnum {
  ZERO = 'None',
  ONE = 'One',
  TWO = 'Two',
  THREE_AND_MORE = 'ThreeOrMore',
}

export enum PreviousInsuranceDurationEnum {
  UNKNOWN = 'Unknown',
  UP_TO_ONE_YEAR = 'UpToOneYear',
  LONGER_THAN_ONE_YEAR = 'LongerThanOneYear',
  LONGER_THAN_THREE_YEAR = 'LongerThanThreeYear',
  LONGER_THAN_FIVE_YEAR = 'LongerThanFiveYear',
}

export enum PreviousInsuranceFinishEnum {
  FROM = 'From',
  OTHER_DATE = 'OtherDate',
}

export enum CoverageTypesEnum {
  LIABILITY = 'Haftpflicht',
  PARTIALLY_COMPREHENSIVE = 'Teilkasko',
  FULLY_COMPREHENSIVE = 'Vollkasko',
}

export enum TariffTypeEnum {
  NORMAL = 'Normal',
}

export enum Errors {
  CONTRACT_PHV_ALREADY_EXISTING = 'CONTRACT_PHV_ALREADY_EXISTING',
  PREVIOUS_INSURANCE_COMPANY_VERTI = 'PREVIOUS_INSURANCE_COMPANY_VERTI',
  CONTRACT_IN_SCHWEBE = 'CONTRACT_IN_SCHWEBE',
}

export enum UrlParams {
  CAMPAIGN_CODE = 'campaignCode',
  PROMOTION_CODE = 'promotionCode',
  REFERRAL_CODE = 'referralCode',
  UTM_SOURCE = 'utm_source',
  UTM_MEDIUM = 'utm_medium',
  UTM_CAMPAIGN = 'utm_campaign',
  UTM_TERM = 'utm_term',
  UTM_CONTENT = 'utm_content',
  UTM_ID = 'utm_id',
  PARTNER_ID = 'partnerid',
  GCLID = 'gclid',
  CLICK_ID = 'click_id',
  DCLID = 'dclid',
  GAD_SOURCE = 'gad_source',
  FBCLID = 'fbclid',
  MSCLKID = 'msclkid',
  GTM_DEBUG = 'gtm_debug',
  TWCLID = 'twclid',
  TTCLID = 'ttclid',
  S_ID = 's_id',
  QS = 'qs',
  AK = 'ak',
}
